import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaSfOther.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(SCENE)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'SCENE'},
            ]
        },
    })
}
